import { configureStore } from "@reduxjs/toolkit";
import authReducer from '../features/auth/authSlice';
import vehiclesReducer from '../features/vehicles/vehiclesSlice';
import clientsReducer from '../features/clients/clientsSlice';
import reservationsReducer from '../features/reservations/reservationsSlice';
import dashboardReducer from '../features/dashboard/dashboardSlice';
import assurancesReducer from '../features/assurances/assurancesSlice';
import contratsReducer from '../features/contrats/contratsSlice';
import facturesReducer from '../features/factures/facturesSlice';
import vidangesReducer from '../features/vidanges/vidangesSlice';
import visitesReducer from '../features/visitesTechniques/visitesTechniquesSlice';
import settingsReducer from '../features/settings/settingsSlice';
import adminReducer from '../features/admin/adminSlice';
import signatureReducer from '../features/signature/signatureSlice';
import cautionsReducer from '../features/cautions/cautionsSlice';
import uiReducer from '../features/ui/uiSlice';
import paiementsReducer from '../features/paiements/paiementsSlice';
import financementsReducer from '../features/financements/financementsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    vehicles: vehiclesReducer,
    clients: clientsReducer,
    reservations: reservationsReducer,
    dashboard: dashboardReducer,
    assurances: assurancesReducer,
    contrats: contratsReducer,
    factures: facturesReducer,
    vidanges: vidangesReducer,
    visites: visitesReducer,
    settings: settingsReducer,
    admin: adminReducer,
    signature: signatureReducer,
    cautions: cautionsReducer,
    ui: uiReducer,
    paiements: paiementsReducer,
    financements: financementsReducer,
  },
});